import { memo, useMemo, useState } from "react";
import "./index.css";

const KeypadNewCartpage = ({ setEnterAmount, enterAmount }) => {
  const [selectedNumber, setSelectedNumber] = useState(null);

  const handleNumberPress = (number) => {
    setSelectedNumber(number);
    setTimeout(() => setSelectedNumber(null), 1000); // Reset color after 1 second
  };

  useMemo(() => {
    const handleKeyDown = (event) => {
      const keyPressed = event.key;
      if (/^[0-9]$/.test(keyPressed)) {
        handleNumberPress(Number(keyPressed));
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const enterAmountFun = (value) => {
    if (enterAmount == "0") {
      setEnterAmount(value);
    } else {
      setEnterAmount(enterAmount + "" + value);
    }
  };

  return (
    <div className="keypad-container-box">
      <div className="paymentCalContainer">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00", "000"].map((number) => (
          <button
            key={number}
            className={`${selectedNumber === number ? "clcInputBox-I" : "clcInputBox-I"}`}
            onClick={() => enterAmountFun(number)}
          >
            {number}
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(KeypadNewCartpage);
